<template>
  <div>
    <div v-if="showText" class="text">
      <span class="highlight">{{ curr }}</span> / {{ total }}
    </div>
    <div class="progress-wrapper">
      <div class="active" :style="styleWidth" />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

const totalLength = 26.67; // vw

@Component({})
export default class Progress extends Vue {
  @Prop({}) total!: number;
  @Prop({}) curr!: number;
  @Prop({ default: false }) showText!: boolean;

  get styleWidth() {
    return `width: ${(this.curr / this.total) * totalLength}vw;`;
  }
}
</script>

<style lang="scss" scoped vars="{ques-theme-bg}">
$theme-color: var(--ques-theme-bg);

.text {
  height: 40px;
  margin-bottom: 16px;
  color: rgba(56, 45, 104, 0.4);
  font-weight: 500;
  font-size: 28px;
  line-height: 40px;
  text-align: center;
}
.highlight {
  color: rgba(56, 45, 104, 1);
}
.progress-wrapper {
  width: 200px;
  height: 8px;
  margin: 0 auto;
  overflow: hidden;
  background-color: #f1f1f6;
  border-radius: 4px;
}
.active {
  height: 8px;
  background-color: $theme-color;
  border-radius: 4px;
  transition: 300ms;
}
</style>


